/** The doc-utility download URL ends with fileName, which may arrive unescaped. */
export function normalizeDocUtilDownloadUrl(value: string, originalFileName?: string): string {
  try {
    const parsed = new URL(value)
    if (!parsed.pathname.endsWith('/doc-utility/get-output-file-direct')) return value

    const fileNameParameter = /[?&]fileName=/.exec(value)
    if (!fileNameParameter) return value

    const fileNameStart = fileNameParameter.index + fileNameParameter[0].length
    const rawFileName = value.slice(fileNameStart)
    const fileName = originalFileName ?? new URLSearchParams(
      `fileName=${rawFileName.replace(/&/g, '%26')}`,
    ).get('fileName')

    // Parse only the prefix so an ampersand or hash in the filename stays part of it.
    const result = new URL(value.slice(0, fileNameParameter.index))
    result.searchParams.set('fileName', fileName)
    return result.toString()
  } catch {
    return value
  }
}
